import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Button,
    FormControl,
    Input,
    FormLabel,
    Select,
  } from "@chakra-ui/react";
  import React, { useState } from "react";
  import { AiFillLock, AiFillUnlock } from "react-icons/ai";
  export default function BookingDateModal({ isOpen, onClose, func,isLock,Data }: any) {
    const [value, setValue] = useState(Data.filterType);
    const [lock, setLock] = useState(isLock);
    const [data, setData] = useState(Data.date);
    const initialRef = React.useRef(null);
  
    return (
      <>
        <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Filter Data By Date</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl>
                <FormLabel>Select Filter Type</FormLabel>
                <Select
                value={value}
                  placeholder="Select option"
                  onChange={(e) => setValue(e.target.value)}
                >
                  <option value="entry_date">Bought Date</option>
                  <option value="session_date">Session Date</option>
                  <option value="booking_date">
                    Booking Date
                  </option>
                </Select>
              </FormControl>
  
              {value !== "" ? (
                <FormControl mt={4}>
                  <FormLabel>Choose date</FormLabel>
                  <Input
                  value={data}
                    type="date"
                    ref={initialRef}
                    onChange={(e) => setData(e.target.value)}
                  />
                </FormControl>
              ) : null}
            </ModalBody>
  
            <ModalFooter>
              {lock ? (
                <Button
                  className="btn "
                  bgColor="#327171"
                  mr={5}
                  color={"white"}
                  type="button"
                  onClick={() => {
                    setLock(false)
                    localStorage.removeItem("booking-list-filter-date");
                  }}
                >
                  <AiFillLock style={{ fontSize: "20px", margin: "0 5px" }} />
                </Button>
              ) : (
                <Button
                  className="btn"
                  bgColor="#327171"
                  mr={5}
                  color={"white"}
                  type="button"
                  onClick={() => {
                    setLock(true)
                    localStorage.setItem(
                      "booking-list-filter-date",
                      JSON.stringify({ filterType: value, date: data })
                    );
                  }}
                >
                  <AiFillUnlock style={{ fontSize: "20px", margin: "0 5px" }} />
                </Button>
              )}
              <Button
                bgColor="#327171"
                color={"white"}
                mr={3}
                onClick={() => {
                  func(data, value,lock);
                  onClose();
                  setData("");
                  setValue("");
                }}
              >
                Submit
              </Button>
              <Button bgColor="red" color={"white"} onClick={onClose}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  }
  